import { InputContext } from 'app/modules/wallforming/components/input-binding/types/inputContext';
import { InteractionMode } from 'app/modules/wallforming/components/scenes/types/interactionMode';

import type { PlacementState } from 'app/modules/wallforming/components/state-management/placement/types';

export const ALL_INPUT_CONTEXTS = Object.values(InputContext);

export const EDIT_CONTEXTS = [InputContext.Placement, InputContext.Navigation, InputContext.Transformation] as const;

/** Mode state machine: the highest-priority active mode wins. */
export function resolveInputContext(
    state: Pick<
        PlacementState,
        'isViewMode' | 'arePivotControlsActive' | 'interactionMode' | 'isPanelQuickReplacementOpen'
    >
): InputContext {
    if (state.isViewMode) {
        return InputContext.View;
    }
    if (state.isPanelQuickReplacementOpen) {
        return InputContext.Configuration;
    }
    if (state.arePivotControlsActive) {
        return InputContext.Transformation;
    }
    return state.interactionMode === InteractionMode.POI_NAVIGATION ? InputContext.Navigation : InputContext.Placement;
}

export function isContextActive(contexts: readonly InputContext[], context: InputContext): boolean {
    return contexts.includes(context);
}

export function contextsOverlap(a: readonly InputContext[], b: readonly InputContext[]): boolean {
    return a.some((context) => b.includes(context));
}

/** Hierarchical scopes (`scene`, `scene.ltr`): bindings only collide when one scope contains the other. */
export function scopesOverlap(a?: string, b?: string): boolean {
    return !a || !b || a === b || a.startsWith(`${b}.`) || b.startsWith(`${a}.`);
}
